import AppConstants from '../config/app.constants';

let BranchFundingSourceOrderProfileService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/branch-funding-source-order-profile`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source-order-profile/create`, {
                data
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source-order-profile/${id}/update`, {
                data
            })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/branch-funding-source-order-profile/${id}/detail`)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/branch-funding-source-order-profile/${id}/delete`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

BranchFundingSourceOrderProfileService.$inject = ['$http', '$q']

export default BranchFundingSourceOrderProfileService;


// WEBPACK FOOTER //
// ./client/app/services/branch-funding-source-order-profile.service.js